import type { ReactNode } from "react";

export function PortalPageIntro({
  title,
  action,
  titleId,
  breadcrumbs,
}: {
  title: string;
  action?: ReactNode;
  titleId?: string;
  breadcrumbs?: ReactNode;
}) {
  return (
    <header className="grid gap-5 border-b-2 border-border-default pb-7 md:grid-cols-[minmax(0,1fr)_auto] md:items-end">
      <div className="min-w-0 space-y-3">
        {breadcrumbs}
        <h1 id={titleId} className="max-w-4xl font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.045em] text-content-primary sm:text-5xl">
          {title}
        </h1>
      </div>
      {action}
    </header>
  );
}

export function PortalMiniLinkCard({
  title,
  description,
  meta,
  onAction,
}: {
  title: string;
  description: string;
  meta?: ReactNode;
  onAction?: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onAction}
      className="flex w-full items-center gap-4 rounded-card border-2 border-border-default bg-surface-base px-5 py-4 text-left shadow-card transition hover:border-accent-strong"
    >
      <div className="min-w-0 flex-1">
        <h3 className="text-sm font-extrabold leading-none text-content-primary">{title}</h3>
        <p className="mt-1.5 text-xs font-medium leading-5 text-content-secondary">{description}</p>
      </div>
      {meta}
      <span className="shrink-0 text-content-secondary" aria-hidden="true">
        →
      </span>
    </button>
  );
}

export function PortalWatermarkIcon({ kind }: { kind: "contracts" | "dialer" | "toolkit" | "people" | "profile" | "document" | "video" | "desktop" }) {
  if (kind === "video") {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35"><rect x="2.5" y="5" width="19" height="14" rx="2.5" /><path strokeLinecap="round" strokeLinejoin="round" d="M10 9.5l5 2.5-5 2.5v-5z" /></svg>;
  }
  if (kind === "desktop") {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35"><rect x="2.5" y="4" width="19" height="12.5" rx="2" /><path strokeLinecap="round" strokeLinejoin="round" d="M8.5 20.5h7M12 16.5v4" /></svg>;
  }
  if (kind === "document") {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35"><path strokeLinecap="round" strokeLinejoin="round" d="M7 3.5h7l5 5V19a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 015 19V5A1.5 1.5 0 017 3.5zm7 0V8h4.5M9 13.5l2 2 4-4.5" /></svg>;
  }
  if (kind === "dialer") {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35"><path strokeLinecap="round" strokeLinejoin="round" d="M7.5 3.5h-2A2.5 2.5 0 003 6c0 8.284 6.716 15 15 15a2.5 2.5 0 002.5-2.5v-2l-5-1.25-1.25 2.5a12.7 12.7 0 01-8-8L8.75 8.5 7.5 3.5z" /></svg>;
  }
  if (kind === "toolkit") {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35"><path strokeLinecap="round" strokeLinejoin="round" d="M9 6V4.5A1.5 1.5 0 0110.5 3h3A1.5 1.5 0 0115 4.5V6m-12 5h18M5 6h14a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2zm5 5v2h4v-2" /></svg>;
  }
  if (kind === "people") {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35"><path strokeLinecap="round" strokeLinejoin="round" d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2m7-10a4 4 0 100-8 4 4 0 000 8zm13 10v-2a4 4 0 00-3-3.87m-2-12a4 4 0 010 7.75" /></svg>;
  }
  if (kind === "profile") {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35"><circle cx="12" cy="8" r="4" /><path strokeLinecap="round" d="M4 21a8 8 0 0116 0" /></svg>;
  }
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5-4.5A12 12 0 0112 3 12 12 0 014 5.5V11c0 5 3.4 9 8 10 4.6-1 8-5 8-10V5.5z" /></svg>;
}
